/**
 * Generated by orval 🍺
 * Do not edit manually.
 * FleetYards.net API
 * OpenAPI spec version: v1
 */
import {
  useMutation,
  useQuery
} from '@tanstack/vue-query';
import type {
  DataTag,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UseMutationOptions,
  UseMutationReturnType,
  UseQueryOptions,
  UseQueryReturnType
} from '@tanstack/vue-query';

import {
  computed,
  toValue,
  unref
} from 'vue';
import type {
  MaybeRefOrGetter
} from 'vue';

import type {
  SchemaValidationErrorResponse,
  StandardError,
  ValidationError,
  VehicleLogEntriesList,
  VehicleLogEntry,
  VehicleLogEntryCreateInput,
  VehicleLogEntryUpdateInput
} from '../../models';

import { axiosClient } from '../../../axiosClient.ts';
import type { ErrorType } from '../../../axiosClient.ts';




/**
 * @summary Create Vehicle Log Entry
 */
export const createVehicleLogEntry = (
    vehicleId: MaybeRefOrGetter<string>,
    vehicleLogEntryCreateInput: MaybeRefOrGetter<VehicleLogEntryCreateInput>,
 signal?: AbortSignal
) => {
      vehicleId = toValue(vehicleId);
vehicleLogEntryCreateInput = toValue(vehicleLogEntryCreateInput);

      return axiosClient<VehicleLogEntry>(
      {url: `/vehicles/${vehicleId}/log-entries`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: vehicleLogEntryCreateInput, signal
    },
      );
    }




export const getCreateVehicleLogEntryMutationKey = () => ['createVehicleLogEntry'] as const;

export const getCreateVehicleLogEntryMutationOptions = <TError = ErrorType<ValidationError | StandardError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createVehicleLogEntry>>, TError,CreateVehicleLogEntryMutationVariables, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof createVehicleLogEntry>>, TError,CreateVehicleLogEntryMutationVariables, TContext> => {

const mutationKey = getCreateVehicleLogEntryMutationKey();
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createVehicleLogEntry>>, CreateVehicleLogEntryMutationVariables> = (props) => {
          const {vehicleId,data} = props ?? {};

          return  createVehicleLogEntry(vehicleId,data,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreateVehicleLogEntryMutationResult = NonNullable<Awaited<ReturnType<typeof createVehicleLogEntry>>>
    export type CreateVehicleLogEntryMutationBody = VehicleLogEntryCreateInput
    export type CreateVehicleLogEntryMutationError = ErrorType<ValidationError | StandardError>
    export type CreateVehicleLogEntryMutationVariables = {vehicleId: string;data: VehicleLogEntryCreateInput}

    /**
 * @summary Create Vehicle Log Entry
 */
export const useCreateVehicleLogEntry = <TError = ErrorType<ValidationError | StandardError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createVehicleLogEntry>>, TError,CreateVehicleLogEntryMutationVariables, TContext>, }
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof createVehicleLogEntry>>,
        TError,
        CreateVehicleLogEntryMutationVariables,
        TContext
      > => {
      return useMutation(getCreateVehicleLogEntryMutationOptions(options), queryClient);
    }
    /**
 * @summary List Vehicle Log Entries
 */
export const vehicleLogEntries = (
    vehicleId: MaybeRefOrGetter<string>,
 signal?: AbortSignal
) => {
      vehicleId = toValue(vehicleId);

      return axiosClient<VehicleLogEntriesList>(
      {url: `/vehicles/${vehicleId}/log-entries`, method: 'GET', signal
    },
      );
    }




export const getVehicleLogEntriesQueryKey = (vehicleId: MaybeRefOrGetter<string>,) => {
    return [
    'vehicles',vehicleId,'log-entries'
    ] as const;
    }


export const getVehicleLogEntriesQueryOptions = <TData = Awaited<ReturnType<typeof vehicleLogEntries>>, TError = ErrorType<SchemaValidationErrorResponse | StandardError>>(vehicleId: MaybeRefOrGetter<string>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof vehicleLogEntries>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  getVehicleLogEntriesQueryKey(vehicleId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof vehicleLogEntries>>> = ({ signal }) => vehicleLogEntries(vehicleId, signal);





   return  { queryKey, queryFn, enabled: computed(() => toValue(vehicleId) !== null && toValue(vehicleId) !== undefined), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof vehicleLogEntries>>, TError, TData>
}

export type VehicleLogEntriesQueryResult = NonNullable<Awaited<ReturnType<typeof vehicleLogEntries>>>
export type VehicleLogEntriesQueryError = ErrorType<SchemaValidationErrorResponse | StandardError>


/**
 * @summary List Vehicle Log Entries
 */

export function useVehicleLogEntries<TData = Awaited<ReturnType<typeof vehicleLogEntries>>, TError = ErrorType<SchemaValidationErrorResponse | StandardError>>(
 vehicleId: MaybeRefOrGetter<string>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof vehicleLogEntries>>, TError, TData>>, }
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getVehicleLogEntriesQueryOptions(vehicleId,options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}






/**
 * @summary Destroy Vehicle Log Entry
 */
export const destroyVehicleLogEntry = (
    vehicleId: MaybeRefOrGetter<string>,
    id: MaybeRefOrGetter<string>,
 signal?: AbortSignal
) => {
      vehicleId = toValue(vehicleId);
id = toValue(id);

      return axiosClient<VehicleLogEntry>(
      {url: `/vehicles/${vehicleId}/log-entries/${id}`, method: 'DELETE', signal
    },
      );
    }




export const getDestroyVehicleLogEntryMutationKey = () => ['destroyVehicleLogEntry'] as const;

export const getDestroyVehicleLogEntryMutationOptions = <TError = ErrorType<SchemaValidationErrorResponse | StandardError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof destroyVehicleLogEntry>>, TError,DestroyVehicleLogEntryMutationVariables, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof destroyVehicleLogEntry>>, TError,DestroyVehicleLogEntryMutationVariables, TContext> => {

const mutationKey = getDestroyVehicleLogEntryMutationKey();
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof destroyVehicleLogEntry>>, DestroyVehicleLogEntryMutationVariables> = (props) => {
          const {vehicleId,id} = props ?? {};

          return  destroyVehicleLogEntry(vehicleId,id,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DestroyVehicleLogEntryMutationResult = NonNullable<Awaited<ReturnType<typeof destroyVehicleLogEntry>>>

    export type DestroyVehicleLogEntryMutationError = ErrorType<SchemaValidationErrorResponse | StandardError>
    export type DestroyVehicleLogEntryMutationVariables = {vehicleId: string;id: string}

    /**
 * @summary Destroy Vehicle Log Entry
 */
export const useDestroyVehicleLogEntry = <TError = ErrorType<SchemaValidationErrorResponse | StandardError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof destroyVehicleLogEntry>>, TError,DestroyVehicleLogEntryMutationVariables, TContext>, }
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof destroyVehicleLogEntry>>,
        TError,
        DestroyVehicleLogEntryMutationVariables,
        TContext
      > => {
      return useMutation(getDestroyVehicleLogEntryMutationOptions(options), queryClient);
    }
    /**
 * @summary Update Vehicle Log Entry
 */
export const updateVehicleLogEntry = (
    vehicleId: MaybeRefOrGetter<string>,
    id: MaybeRefOrGetter<string>,
    vehicleLogEntryUpdateInput: MaybeRefOrGetter<VehicleLogEntryUpdateInput>,
 signal?: AbortSignal
) => {
      vehicleId = toValue(vehicleId);
id = toValue(id);
vehicleLogEntryUpdateInput = toValue(vehicleLogEntryUpdateInput);

      return axiosClient<VehicleLogEntry>(
      {url: `/vehicles/${vehicleId}/log-entries/${id}`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: vehicleLogEntryUpdateInput, signal
    },
      );
    }




export const getUpdateVehicleLogEntryMutationKey = () => ['updateVehicleLogEntry'] as const;

export const getUpdateVehicleLogEntryMutationOptions = <TError = ErrorType<ValidationError | StandardError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateVehicleLogEntry>>, TError,UpdateVehicleLogEntryMutationVariables, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof updateVehicleLogEntry>>, TError,UpdateVehicleLogEntryMutationVariables, TContext> => {

const mutationKey = getUpdateVehicleLogEntryMutationKey();
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateVehicleLogEntry>>, UpdateVehicleLogEntryMutationVariables> = (props) => {
          const {vehicleId,id,data} = props ?? {};

          return  updateVehicleLogEntry(vehicleId,id,data,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UpdateVehicleLogEntryMutationResult = NonNullable<Awaited<ReturnType<typeof updateVehicleLogEntry>>>
    export type UpdateVehicleLogEntryMutationBody = VehicleLogEntryUpdateInput
    export type UpdateVehicleLogEntryMutationError = ErrorType<ValidationError | StandardError>
    export type UpdateVehicleLogEntryMutationVariables = {vehicleId: string;id: string;data: VehicleLogEntryUpdateInput}

    /**
 * @summary Update Vehicle Log Entry
 */
export const useUpdateVehicleLogEntry = <TError = ErrorType<ValidationError | StandardError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateVehicleLogEntry>>, TError,UpdateVehicleLogEntryMutationVariables, TContext>, }
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof updateVehicleLogEntry>>,
        TError,
        UpdateVehicleLogEntryMutationVariables,
        TContext
      > => {
      return useMutation(getUpdateVehicleLogEntryMutationOptions(options), queryClient);
    }
